import { ApplicationsConstant } from "./constant";

export const ApplicationsReducers = function (state = {}, action) {
  switch (action.type) {
    case ApplicationsConstant.GET_APPLICATIONS_LIST_REQUEST:
      return {
        ...state,
        send: true,
        sendApplications: true,
        applicationsList: null
      };
    case ApplicationsConstant.GET_APPLICATIONS_LIST_SUCCESS:
      return {
        ...state,
        send: false,
        sendApplications: false,
        applicationsList: action.payload
      };
    case ApplicationsConstant.GET_APPLICATIONS_LIST_ERROR:
      return {
        ...state,
        send: false,
        sendApplications: false,
        errors: action.error
      };
    case ApplicationsConstant.GET_APPLICATIONS_EXCEL_LIST_ERROR:
      return {
        ...state,
        errors: action.error
      };
    case ApplicationsConstant.GET_MANUAL_RISK_LIST_REQUEST:
      return {
        ...state,
        send: true,
        sendManualRiskList: true,
        manualRiskList: null
      };
    case ApplicationsConstant.GET_MANUAL_RISK_LIST_SUCCESS:
      return {
        ...state,
        send: false,
        sendManualRiskList: false,
        manualRiskList: action.payload
      };
    case ApplicationsConstant.GET_MANUAL_RISK_LIST_ERROR:
      return {
        ...state,
        send: false,
        sendManualRiskList: false,
        errors: action.error
      };

    case ApplicationsConstant.SET_MANUAL_RISK_LIST_REQUEST:
      return {
        ...state,
        send: true,
        setSendManualRiskList: true
      };
    case ApplicationsConstant.SET_MANUAL_RISK_LIST_SUCCESS:
      return {
        ...state,
        send: false,
        setSendManualRiskList: false
      };
    case ApplicationsConstant.SET_MANUAL_RISK_LIST_ERROR:
      return {
        ...state,
        send: false,
        setSendManualRiskList: false,
        errors: action.error
      };
    case ApplicationsConstant.GET_SANCTIONS_LIST_REQUEST:
      return {
        ...state,
        isLoadingSanctions: true,
        sanctionsList: null
      };
    case ApplicationsConstant.GET_SANCTIONS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingSanctions: false,
        sanctionsList: action.payload
      };
    case ApplicationsConstant.GET_SANCTIONS_LIST_ERROR:
      return {
        ...state,
        isLoadingSanctions: false,
        errors: action.error
      };
    case ApplicationsConstant.REVIEW_SANCTION_REQUEST:
      return {
        ...state,
        isReviewSanctionLoading: true
      };
    case ApplicationsConstant.REVIEW_SANCTION_SUCCESS: {
      return {
        ...state,
        isReviewSanctionLoading: false,
        sanctionsList: action.payload.sanctions,
        application: {
          ...state.application,
          actions: action.payload.state.availableActions
        }
      };
    }

    case ApplicationsConstant.REVIEW_SANCTION_ERROR:
      return {
        ...state,
        isReviewSanctionLoading: false,
        errors: action.error
      };
    case ApplicationsConstant.ALL_SANCTION_REVIEWED_REQUEST:
      return {
        ...state,
        isAllSanctionReviewsLoading: true
      };
    case ApplicationsConstant.ALL_SANCTION_REVIEWED_SUCCESS:
      return {
        ...state,
        isAllSanctionReviewsLoading: false,
        application: action.payload
      };
    case ApplicationsConstant.ALL_SANCTION_REVIEWED_ERROR:
      return {
        ...state,
        errors: action.error,
        isAllSanctionReviewsLoading: false
      };
    case ApplicationsConstant.GET_DOCUMENTS_REQUEST:
      return {
        ...state,
        send: true,
        sendDocuments: true,
        documentsList: null
      };
    case ApplicationsConstant.GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        send: false,
        sendDocuments: false,
        documentsList: action.payload
      };
    case ApplicationsConstant.GET_DOCUMENTS_ERROR:
      return {
        ...state,
        send: false,
        sendDocuments: false,
        errors: action.error
      };
    case ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_ERROR:
      return {
        ...state,
        send: false,
        sendDocuments: false,
        errors: action.error
      };
    case ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_SUCCESS:
      return {
        ...state,
        send: false,
        sendDocuments: false,
        documentsList: action.payload
      };
    case ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_REQUEST:
      return {
        ...state,
        send: true,
        sendDocuments: true,
        documentsList: null
      };
    case ApplicationsConstant.GET_APPLICATION_REQUEST:
      return {
        ...state,
        send: true,
        sendApplication: true
      };
    case ApplicationsConstant.GET_APPLICATION_SUCCESS:
      return {
        ...state,
        send: false,
        sendApplication: false,
        application: action.payload
      };
    case ApplicationsConstant.GET_APPLICATION_ERROR:
      return {
        ...state,
        send: false,
        sendApplication: false,
        errors: action.error
      };
    case ApplicationsConstant.REJECT_APPLICATION_REQUEST:
      return {
        ...state,
        send: true,
        sendAction: true,
        isRejectAppLoading: true
      };
    case ApplicationsConstant.REJECT_APPLICATION_SUCCESS:
      return {
        ...state,
        send: false,
        isRejectAppLoading: false,
        sendAction: false,
        application: action.payload
      };
    case ApplicationsConstant.REJECT_APPLICATION_ERROR:
      return {
        ...state,
        send: false,
        sendAction: false,
        isRejectAppLoading: false,
        errors: action.error
      };
    case ApplicationsConstant.REJECT_DUE_SANCTION_LIST_REQUEST:
      return {
        ...state,
        send: true,
        sendAction: true
      };
    case ApplicationsConstant.REJECT_DUE_SANCTION_LIST_SUCCESS:
      return {
        ...state,
        send: false,
        sendAction: false,
        application: action.payload.application
      };
    case ApplicationsConstant.REJECT_DUE_SANCTION_LIST_ERROR:
      return {
        ...state,
        send: false,
        sendAction: false,
        errors: action.error
      };
    case ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_REQUEST:
      return {
        ...state,
        isRequestAdditionaDocsLoading: true
      };
    case ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isRequestAdditionaDocsLoading: false
      };
    case ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_ERROR:
      return {
        ...state,
        isRequestAdditionaDocsLoading: false,
        errors: action.error
      };
    case ApplicationsConstant.APPROVE_RISK_REQUEST:
      return {
        ...state,
        send: true,
        sendAction: true
      };
    case ApplicationsConstant.APPROVE_RISK_SUCCESS: {
      return {
        ...state,
        send: false,
        application: action.payload,
        sendAction: false
      };
    }
    case ApplicationsConstant.APPROVE_RISK_ERROR:
      return {
        ...state,
        send: false,
        sendAction: false,
        errors: action.error
      };
    case ApplicationsConstant.ADD_RISK_REQUEST:
      return {
        ...state,
        send: true,
        sendAction: true,
        isAddRiskLoading: true
      };
    case ApplicationsConstant.ADD_RISK_SUCCESS:
      return {
        ...state,
        send: false,
        sendAction: false,
        isAddRiskLoading: false
      };
    case ApplicationsConstant.ADD_RISK_ERROR:
      return {
        ...state,
        send: false,
        sendAction: false,
        errors: action.error,
        isAddRiskLoading: false
      };
    case ApplicationsConstant.APPROVE_BENEFICIARIES_REQUEST:
      return {
        ...state,
        isApproveBeneficiaresLoading: true
      };
    case ApplicationsConstant.APPROVE_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isApproveBeneficiaresLoading: false
      };
    case ApplicationsConstant.APPROVE_BENEFICIARIES_ERROR:
      return {
        ...state,
        isApproveBeneficiaresLoading: false,
        errors: action.error
      };
    case ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_REQUEST:
      return {
        ...state,
        isUploadingAppDocuments: true
      };
    case ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        isUploadingAppDocuments: false,
        sendAction: false,
        application: action.payload
      };
    }
    case ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_ERROR:
      return {
        ...state,
        isUploadingAppDocuments: false,
        errors: action.error
      };
    case ApplicationsConstant.SET_REVIEW_KYC_STATUS_REQUEST:
      return {
        ...state,
        isReviewKycStatusLoading: true
      };
    case ApplicationsConstant.SET_REVIEW_KYC_STATUS_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isReviewKycStatusLoading: false
      };
    case ApplicationsConstant.SET_REVIEW_KYC_STATUS_ERROR:
      return {
        ...state,
        errors: action.error,
        isReviewKycStatusLoading: false
      };
    case ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_REQUEST:
      return {
        ...state,
        isConfirmUploadedAgreementLoading: true
      };
    case ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isConfirmUploadedAgreementLoading: false
      };
    case ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_ERROR:
      return {
        ...state,
        errors: action.error,
        isConfirmUploadedAgreementLoading: false
      };
    case ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_REQUEST:
      return {
        ...state,
        isRejectUploadedAgreementLoading: true
      };
    case ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isRejectUploadedAgreementLoading: false
      };
    case ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_ERROR:
      return {
        ...state,
        errors: action.error,
        isRejectUploadedAgreementLoading: false
      };
    case ApplicationsConstant.GET_CLIENT_RISKS_LIST_REQUEST:
      return {
        ...state,
        isClientRisksListLoading: true
      };
    case ApplicationsConstant.GET_CLIENT_RISKS_LIST_SUCCESS:
      return {
        ...state,
        applicationRisksList: action.payload?.riskItems,
        isClientRisksListLoading: false
      };
    case ApplicationsConstant.GET_CLIENT_RISKS_LIST_ERROR:
      return {
        ...state,
        errors: action.error,
        isClientRisksListLoading: false
      };
    case ApplicationsConstant.UPDATE_RISK_HIT_REQUEST:
      return {
        ...state,
        isRiskUpdateLoading: true
      };
    case ApplicationsConstant.UPDATE_RISK_HIT_SUCCESS: {
      return {
        ...state,
        applicationRisksList: action.payload.risks.riskItems,
        isRiskUpdateLoading: false,
        application: action.payload
      };
    }
    case ApplicationsConstant.UPDATE_RISK_HIT_ERROR:
      return {
        ...state,
        errors: action.error,
        isRiskUpdateLoading: false
      };
    case ApplicationsConstant.SET_MISSING_DOCUMENTS_REQUEST:
      return {
        ...state,
        isRequestAdditionaoDocsLoading: true
      };
    case ApplicationsConstant.SET_MISSING_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isRequestAdditionaoDocsLoading: false,
        application: action.payload
      };
    case ApplicationsConstant.MODIFY_SELECTED_APP_STATE:
      return {
        ...state,
        application: {
          ...state.application,
          state: action.payload
        }
      };
    case ApplicationsConstant.MODIFY_SELECTED_APP_ACTIONS:
      return {
        ...state,
        application: {
          ...state.application,
          actions: action.payload
        }
      };
    case ApplicationsConstant.CLEAR_SINGLE_APP_STATE:
      return {
        ...state,
        application: undefined,
        sanctionsList: undefined
      };
    // case ApplicationsConstant.CLEAR_APPROVED_RISKS:
    //   return {
    //     ...state,
    //     approvedRisksFormatted: undefined
    //   };
    case ApplicationsConstant.SET_MISSING_DOCUMENTS_ERROR:
      return {
        ...state,
        isRequestAdditionaoDocsLoading: false,
        errors: action.error
      };
    default:
      return state;
  }
};
